import { ESTADOS } from "#colaborador/Solicitudes/constants"
import ButtonIcon from "#common/buttons/ButtonIcon"
import CancelIcon from "@mui/icons-material/Cancel"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import Stack from "@mui/material/Stack"
import { Fragment, useState } from "react"
import TableDialog from "./TableDialog"

export default function TableButtons({ saving_id }) {
	const [data, setData] = useState(false)

	return (
		<Fragment>
			<Stack
				direction={{ xs: "column", sm: "row" }}
				spacing={2}
				justifyContent={"start"}
			>
				<ButtonIcon
					title="Aprobar"
					onClick={() => {
						setData({ open: true, status: ESTADOS.APROBADO })
					}}
					sx={{ color: "green" }}
					icon={<CheckCircleIcon />}
				/>
				<ButtonIcon
					title="Rechazar"
					aria-label="Rechazado"
					onClick={() => {
						setData({ open: true, status: ESTADOS.RECHAZADO })
					}}
					sx={{ color: "red" }}
					icon={<CancelIcon />}
				/>
			</Stack>

			<TableDialog
				saving_id={saving_id}
				status={data.status}
				open={data.open}
				setOpen={setData}
			/>
		</Fragment>
	)
}
